import React from 'react';
import { compose } from 'recompose';
import { Table, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core';
import PrintHeader from '../PrintHeader';

const CustomTableCell = withStyles(() => ({
  head: {
    border: '1px solid #D7D7D7'
  },
  body: {
    fontSize: 12,
    border: '1px solid #D7D7D7',
    padding : 4,
    paddingLeft : 8
  }
}))(TableCell);

const styles = () => ({
  tableHead: {
    backgroundColor: '#F7F7F7'
  },
  table: {
    margin: 0,
    marginTop : 16,
    width: '100%'
  },
  serviceWindow: {
    minWidth: 80
  },
  timeCell: {
    width: 30
  },
  status: {
    minWidth: 130
  },
  activityCell : {
    minWidth : 150
  },
  pageBreak: { pageBreakAfter: 'always' },
  routeHeader: {
    display: 'flex',
    marginLeft: 0,
    marginTop: 32,
    fontWeight: 600,
    textTransform: 'uppercase',
    '&>div:not(:last-child)': {
      borderRight: '1px solid black',
      marginRight: 16,
      paddingRight: 16
    }
  },
  tableRow: {
    pageBreakInside: 'avoid'
  }
});
const PrintTable = ({
  classes,
  printData = [],
  terminalCode,
  driverName,
  driverNumber,
  printRef,
  printEachRouteReportOnNewPage,
  dispatchDate,
}) => {
  return (
    <div ref={printRef}>
      <PrintHeader
        driverName={driverName}
        driverNumber={driverNumber}
        terminalCode={terminalCode}
        dispatchDate={dispatchDate}
      />
      {printData?.map((row) => (
        <div
          key={row.manifestNumber}
          className={printEachRouteReportOnNewPage ? classes.pageBreak : ''}>
          <div className={classes.routeHeader}>
            <div>Manifest {row.manifestNumber}</div>
            <div align="left">Trailer {row.trailerNumber}</div>
            <div align="left">
              Made Standard {row.totalStopsMadeStandard}/{row.totalStops}
            </div>
            <div align="left">
              Missed Standard {row.totalStopsMissedStandard}/{row.totalStops}
            </div>
          </div>
          <Table className={classes.table}>
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.tableRow}>
                <CustomTableCell>Time</CustomTableCell>
                <CustomTableCell align="center">Activity</CustomTableCell>
                <CustomTableCell align="center">Arr Time</CustomTableCell>
                <CustomTableCell align="center">Dept Time</CustomTableCell>
                <CustomTableCell align="center">LG</CustomTableCell>
                <CustomTableCell align="center">Planned Stop Time</CustomTableCell>
                <CustomTableCell align="center">Actual Stop Time</CustomTableCell>
                <CustomTableCell align="center">Status</CustomTableCell>
                <CustomTableCell align="center">Service Window</CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {row.stops.map((row) => (
                <TableRow key={row.id} className={classes.tableRow}>
                  <CustomTableCell className={classes.timeCell}>{row.time}</CustomTableCell>
                  <CustomTableCell align="left" className={classes.activityCell}>
                    {row.activity}
                  </CustomTableCell>
                  <CustomTableCell align="left" className={classes.timeCell}>
                    {row.arrivalTime}
                  </CustomTableCell>
                  <CustomTableCell align="left" className={classes.timeCell}>
                    {row.departureTime}
                  </CustomTableCell>
                  <CustomTableCell align="left" className={classes.timeCell}>
                    {row.liftgate}
                  </CustomTableCell>
                  <CustomTableCell align="left" className={classes.timeCell}>{row.plannedStopTime}</CustomTableCell>
                  <CustomTableCell align="left" className={classes.timeCell}>{row.actualStopTime}</CustomTableCell>
                  <CustomTableCell align="left" className={classes.status}>
                    {row.status}
                  </CustomTableCell>
                  <CustomTableCell align="left" className={classes.serviceWindow}>
                    {row.serviceWindow}
                  </CustomTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ))}
    </div>
  );
};

export default compose(withStyles(styles))(PrintTable);
